import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgInfoCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 22q10 0 10-10T12 2 2 12t10 10M10.75 6.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M14.25 17a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2v-4.5a1 1 0 0 1-.447-1.894l1-.5A1 1 0 0 1 13.25 10v6a1 1 0 0 1 1 1'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgInfoCircle)
export default ForwardRef
